import React, { useRef } from "react";
import { Link } from "react-router-dom";
import SkeletonElement from "../skeletons/skeletonElement";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { EcobookProfile } from "../../types";
import { CiUser } from "react-icons/ci";
import { useDispatch } from "react-redux";
import { setChatWith } from "../../redux/slices/communityFeedSlice";

type ProfileCardProps = {
  userDetails?: EcobookProfile;
  loading: boolean;
  creatorID?: string;
};
const ProfileCard: React.FC<ProfileCardProps> = ({
  userDetails,
  loading,
  creatorID,
}) => {
  // const dispatch = useDispatch();

  // const userDetails = useSelector((state: any) => state.user.userDetails);
  // const userID = window.localStorage.getItem("user");

  // const { loading } = useQuery(PROFILE_DETAILS, {
  //   variables: {
  //     where: {
  //       id: userID,
  //     },
  //   },
  //   onCompleted: (data) => {
  //     console.log(data.user);
  //     dispatch(setUserDetails(data.user));
  //   },
  //   onError: (error) => {
  //     console.log(error);
  //     // showToast(error.message, "error");
  //     // navigate("/auth");
  //   },
  // });
  const [, setProfileImages] = React.useState<File | null>(null);

  // console.log(userDetails?.ecobookProfile);
  // const profileImage = userDetails?.ecobookProfile.profileImage;
  let profileImage: string | null = "";

  if (
    userDetails?.ecobookProfile &&
    userDetails.ecobookProfile.profileImage &&
    userDetails.ecobookProfile.profileImage !== null
  ) {
    const _profileImage = userDetails.ecobookProfile.profileImage;

    if (_profileImage !== null && _profileImage !== undefined) {
      profileImage = _profileImage;
    }
  }
  const [, setImageUpload] = React.useState<string | undefined>(profileImage);
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const file = e.target.files?.[0];

    if (file) {
      setProfileImages(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUpload(reader.result as string);
      };

      reader.readAsDataURL(file);
    }
  };
  const fileInputRef = useRef<HTMLInputElement>(null);
  // const handleIconClick = () => {
  //   fileInputRef.current!.click();
  // };

  const userID = window.localStorage.getItem("user");
  const dispatch = useDispatch();

  let chatID: any;
  if (userID && userDetails?.id) {
    if (userID.localeCompare(userDetails?.id) < 0) {
      chatID = `${userID}${userDetails?.id}`;
    } else if (userID.localeCompare(userDetails?.id) > 0) {
      chatID = `${userDetails?.id}${userID}`;
    }
  }
  // console.log("chatID: ", chatID);
  // console.log("profileImage: ", profileImage);
  // console.log(`name: ${userDetails?.firstName} ${userDetails?.lastName}`);

  const chatDetails = {
    id: chatID,
    profileImage: profileImage || null,
    name: `${userDetails?.firstName} ${userDetails?.lastName}`,
  };

  return (
    <div className="flex flex-col lg:flex-row pt-4 lg:pt-0 justify-between w-full">
      <div className="flex flex-col lg:flex-row lg:w-[55%] gap-4">
        <div className="flex gap-5 items-center">
          <div className="flex relative lg:w-40 lg:h-40 w-[52px] h-[52px]">
            {profileImage && profileImage ? (
              <img
                alt=""
                src={ipfsGatewayImage(profileImage!)}
                className="lg:w-40 lg:h-40 w-[52px] h-[52px] rounded-full"
              />
            ) : (
              <div className="lg:w-40 lg:h-40 w-[52px] h-[52px] bg-slate-100 flex items-center justify-center rounded-full">
                <CiUser size={20} />
              </div>
            )}
            {/* <div className="absolute right-5 bottom-2 w-6 h-6 shadow-sm pl-[5px] flex items-center text-center align-middle rounded-full bg-greyEdit outline outline-4 outline-comPagBg">
              <PiPencilSimpleDuotone
                size={12}
                className="cursor-pointer"
                onClick={handleIconClick}
              />
            </div> */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleImageChange}
              className="invisible hidden"
            />
          </div>
          <div className="flex flex-col lg:hidden">
            {loading ? (
              <SkeletonElement type="tittle" />
            ) : (
              <>
                <h1 className="font-Poppins text-base font-bold text-transBlack">
                  {`${userDetails?.firstName} ${userDetails?.lastName}`}
                </h1>
                <h4 className="font-Poppins text-[10px]">
                  ({userDetails?.username})
                </h4>
              </>
            )}
          </div>
        </div>
        <div className="lg:grid lg:grid-rows-4 lg:h-40 flex justify-between items-center lg:items-start">
          <div className=" hidden lg:grid lg:row-start-1 mt-8 lg:row-span-2">
            {loading ? (
              <SkeletonElement type="tittle" />
            ) : (
              <>
                <h1 className="font-Poppins text-xl font-bold text-transBlack">
                  {`${userDetails?.firstName} ${userDetails?.lastName}`}
                </h1>
                <h4 className="font-Nunito text-sm">
                  ({userDetails?.username})
                </h4>
              </>
            )}
          </div>
          <div className="lg:row-span-1 lg:row-start-4">
            {/* <div className="flex flex-row gap-1">
              <div className="flex">
                <img alt="" src={Astro} className="w-8 h-8 rounded-full" />
                <img
                  alt=""
                  src={Market}
                  className="w-8 h-8 rounded-full lg:ml-[-23px] ml-[-18px]"
                />
                <img
                  alt=""
                  src={Nort}
                  className="w-8 h-8 rounded-full lg:ml-[-23px] ml-[-18px]"
                />
                <img
                  alt=""
                  src={Astro}
                  className="w-8 h-8 rounded-full lg:ml-[-23px] ml-[-18px]"
                />
                <img
                  alt=""
                  src={Nort}
                  className="w-8 h-8 rounded-full lg:ml-[-23px] ml-[-18px]"
                />
              </div>
              <div className="font-Poppins text-black text-xs">
                <p className="mt-2">1k+ Followers</p>
              </div>
            </div> */}
          </div>
          <div className="flex gap-2 cursor-pointer lg:hidden justify-end">
            {userID === creatorID ? (
              <Link to="edit-profile">
                <div className="bg-midGreen text-white rounded shadow flex h-7 w-24 active:w-20 active:text-lightGreen active:mr-1 transition-all duration-500 mb-1 items-center justify-center font-Poppins text-[10px]">
                  Edit Profile
                </div>
              </Link>
            ) : (
              <Link to={`/chat/e/${chatID}`}>
                <div
                  className="bg-midGreen text-white rounded shadow flex h-7 w-24 active:w-20 active:text-lightGreen active:mr-1 transition-all duration-500 mb-1 items-center justify-center font-Poppins text-[10px]"
                  onClick={() => dispatch(setChatWith(chatDetails))}
                >
                  Message
                </div>
              </Link>
            )}
            {/* <div className="bg-midGreen text-white rounded shadow w-12 h-7 flex text-center justify-center items-center font-Poppins text-[10px]">
              Ads
            </div>
            <div className="bg-midGreen rounded shadow w-8 h-7 flex items-center justify-center">
              <CiSettings size={20} fill="white" />
            </div> */}
          </div>
        </div>
      </div>
      <div className="lg:grid lg:grid-rows-4 hidden w-[30%]">
        <div className="row-start-4">
          <div className="flex gap-2 cursor-pointer justify-end">
            {userID === creatorID ? (
              <Link to="edit-profile">
                <div className="bg-midGreen text-white rounded shadow flex h-7 w-24 active:w-20 active:text-lightGreen active:mr-1 transition-all duration-500 mb-1 items-center justify-center font-Poppins text-[10px]">
                  Edit Profile
                </div>
              </Link>
            ) : (
              <Link to={`/chat/e/${chatID}`}>
                <div
                  className="bg-midGreen text-white rounded shadow flex h-7 w-24 active:w-20 active:text-lightGreen active:mr-1 transition-all duration-500 mb-1 items-center justify-center font-Poppins text-[10px]"
                  onClick={() => dispatch(setChatWith(chatDetails))}
                >
                  Message
                </div>
              </Link>
            )}
            {/* <div className="bg-midGreen text-white rounded shadow w-12 h-7 flex text-center justify-center items-center font-Poppins text-[10px]">
              Ads
            </div>
            <div className="bg-midGreen rounded shadow w-8 h-7 flex items-center justify-center">
              <CiSettings size={20} fill="white" />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
